import { baseApi } from '@/shared/api/baseApi';
import type { CreateOrderRequestPayload, CreateSaleResult, OrderRequestDto, OrderRequestListPage } from '../model/types';

const orderRequestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // ---- Владелец --------------------------------------------------------------------------
    listOrderRequests: builder.query<OrderRequestListPage, { status?: string; cursor?: string } | void>({
      query: (params) => ({ url: 'order-requests', params: params ?? undefined }),
      providesTags: ['OrderRequestList'],
    }),
    orderRequestCount: builder.query<{ new: number }, void>({
      query: () => 'order-requests/count',
      providesTags: ['OrderRequestList'],
    }),
    getOrderRequest: builder.query<OrderRequestDto, string>({
      query: (id) => `order-requests/${id}`,
      providesTags: (_r, _e, id) => [{ type: 'OrderRequest', id }],
    }),
    acceptOrderRequest: builder.mutation<OrderRequestDto, string>({
      query: (id) => ({ url: `order-requests/${id}/accept`, method: 'POST' }),
      invalidatesTags: (_r, _e, id) => [{ type: 'OrderRequest', id }, 'OrderRequestList'],
    }),
    rejectOrderRequest: builder.mutation<OrderRequestDto, string>({
      query: (id) => ({ url: `order-requests/${id}/reject`, method: 'POST' }),
      invalidatesTags: (_r, _e, id) => [{ type: 'OrderRequest', id }, 'OrderRequestList'],
    }),
    createSaleFromOrderRequest: builder.mutation<CreateSaleResult, string>({
      query: (id) => ({ url: `order-requests/${id}/create-sale`, method: 'POST' }),
      invalidatesTags: (_r, _e, id) => [{ type: 'OrderRequest', id }, 'OrderRequestList', 'DocumentList', 'DocumentSummary'],
    }),

    // ---- Клиент ------------------------------------------------------------------------------
    myOrderRequests: builder.query<OrderRequestDto[], void>({
      query: () => 'client/order-requests',
      providesTags: ['OrderRequestList'],
    }),
    createOrderRequest: builder.mutation<OrderRequestDto, CreateOrderRequestPayload>({
      query: (body) => ({ url: 'client/order-requests', method: 'POST', body }),
      invalidatesTags: ['OrderRequestList'],
    }),
  }),
});

export const {
  useListOrderRequestsQuery,
  useOrderRequestCountQuery,
  useGetOrderRequestQuery,
  useAcceptOrderRequestMutation,
  useRejectOrderRequestMutation,
  useCreateSaleFromOrderRequestMutation,
  useMyOrderRequestsQuery,
  useCreateOrderRequestMutation,
} = orderRequestApi;

export { orderRequestApi };
